import { render, staticRenderFns } from "./WorkspacePermissions.vue?vue&type=template&id=03e1dab4&scoped=true&"
import script from "./WorkspacePermissions.vue?vue&type=script&lang=js&"
export * from "./WorkspacePermissions.vue?vue&type=script&lang=js&"
import style0 from "./WorkspacePermissions.vue?vue&type=style&index=0&id=03e1dab4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e1dab4",
  null
  
)

export default component.exports